/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { FittingPrioritizationComponent } from "../../components/fitting-prioritization/fitting-prioritization.component";
import { GlobalConstants } from "../../constants/global-constants";
import { SysquePopupConfig } from "../../models/sysque-popup-config";
import { PopupDialog } from "../popup-dialog.interface";

export class FittingPrioritizationDialog implements PopupDialog {

    create(sysquePopupConfig: SysquePopupConfig): any {
        sysquePopupConfig.component = FittingPrioritizationComponent;
        sysquePopupConfig.data = null;
        sysquePopupConfig.width = 450;
        sysquePopupConfig.height = 712;
        sysquePopupConfig.componentTitle = GlobalConstants.FittingPrioritizationTitle;
    }
}
